
const getDictOfAttributes = function (query, map = (el) => el) {
  let attributes = getAttributes(query)
  let d = {}
  for (let att of attributes) {
    if (!d[att.id]) {
      d[att.id] = []
    }
    d[att.id].push(map(att))
  }
  return d
}

const getAttributes = function (query) {
  let attributes = []
  for (let seg of query) {
    if (Array.isArray(seg)) {
      attributes.push.apply(attributes, getAttributes(seg))
    } else if (seg.id) {
      attributes.push(seg)
    }
  }
  return attributes
}

export {
  getDictOfAttributes,
  getAttributes
}



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/targetDefinition.js